import { initializeApp, getApps, getApp } from 'firebase/app';
import { getFirestore, initializeFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import {
  getAuth,
  connectAuthEmulator,
  setPersistence,
  indexedDBLocalPersistence,
  browserLocalPersistence,
} from 'firebase/auth';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getDatabase, connectDatabaseEmulator } from 'firebase/database';
import { initAppCheck } from './appCheck';

/**
 * Build/dev com `--mode emulator` (ver `npm run emu:*` e .env.emulator): o
 * app inteiro fala com os emuladores locais, num projeto `demo-dratento` —
 * dá pra testar gravação (cobrança, status…) sem encostar em produção. O
 * build normal nunca entra aqui.
 */
export const USING_EMULATORS = import.meta.env.MODE === 'emulator';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL,
};

// Initialize Firebase
const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

// App Check ANTES dos serviços: o SDK só anexa o token automaticamente
// (Firestore/Storage/RTDB) se o interceptor existir na hora em que os
// clientes são criados. No-op sem VITE_APPCHECK_RECAPTCHA_KEY.
initAppCheck(app);

// Emulador: long polling — o WebKit do Playwright no Windows (iPhone do
// `npm run emu:iphone` / testes) não entrega o canal contínuo do Firestore.
export const db = USING_EMULATORS
  ? initializeFirestore(app, { experimentalForceLongPolling: true })
  : getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export const rtdb = getDatabase(app);

// Portas em firebase.json › emulators. Antes de qualquer leitura/escrita.
if (USING_EMULATORS) {
  connectAuthEmulator(auth, 'http://127.0.0.1:9099');
  connectFirestoreEmulator(db, '127.0.0.1', 8080);
  connectStorageEmulator(storage, '127.0.0.1', 9199);
  connectDatabaseEmulator(rtdb, '127.0.0.1', 9000);
}

// Persistencia explicita do login: tenta IndexedDB primeiro (mais robusto,
// sobrevive a fechar o navegador) e cai pra localStorage como fallback.
// Sem isso, alguns navegadores fazem fallback silencioso pra "in-memory",
// o que faz o usuario ser deslogado ao fechar a aba ou ao expirar o token.
setPersistence(auth, indexedDBLocalPersistence).catch(() => {
  setPersistence(auth, browserLocalPersistence).catch((err) => {
    console.warn('[auth] Nao foi possivel configurar persistencia local:', err);
  });
});

export default app;
